<template>
  <v-dialog v-model="isOpen" max-width="420" persistent>
    <v-card class="bf-required pa-6" rounded="xl" elevation="10">
      <!-- Cabeçalho com ícone -->
      <div class="text-center mb-4">
        <div class="bf-required__icon">
          <v-icon color="white" size="30">mdi-lock</v-icon>
        </div>
        <h3 class="bf-required__title mt-3">Acesso Suspenso</h3>
      </div>

      <!-- Texto explicativo -->
      <v-card-text class="bf-required__text text-center">
        Olá! Identificamos uma pendência no pagamento da sua assinatura. <br />
        Para reativar sua conta e ter acesso completo à plataforma, por favor, regularize sua situação.
        <!--
        <br /><br />
        Caso já tenha efetuado o pagamento,
        <a href="#" class="text-primary font-weight-medium">clique aqui</a>.
        -->
      </v-card-text>

      <!-- Ações -->
      <v-card-actions class="d-flex flex-column mt-4">
        <v-btn
          block
          color="primary"
          class="mb-2 text-none"
          rounded="lg"
          size="large"
          @click="goToSubscriptions"
        >
          <v-icon start>mdi-credit-card</v-icon>
          Regularizar Pagamento Agora
        </v-btn>

        <v-btn
          block
          variant="outlined"
          class="text-none"
          rounded="lg"
          size="large"
          @click="logoutNow"
        >
          <v-icon start>mdi-logout</v-icon>
          Sair da Conta
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth.store";
import { useAuth } from "@/composables/useAuth";

export default defineComponent({
  name: "PaymentRequiredModal",
  setup() {
    const authStore = useAuthStore();
    const route = useRoute();
    const router = useRouter();
    const { logout } = useAuth();

    const isOpen = computed({
      get: () => {
        const token = authStore.getToken;
        const billing = authStore.getBillingStatus;
        const isAuthRoute = [
          "SignInPage",
          "SignUpPage",
          "ForgotPasswordPage",
          "ResetPasswordPage",
          "EmailValidationPage",
        ].includes(route.name as string);
        const isPaymentRoute = [
          "SubscriptionsPage",
          "PaymentHistoryPage",
        ].includes(route.name as string);
        return !!token && billing === false && !isAuthRoute && !isPaymentRoute;
      },
      set: () => {
        // no-op: modal is controlled by computed state
      },
    });

    const goToSubscriptions = () => {
      router.push({ name: "SubscriptionsPage" });
    };

    const logoutNow = async () => {
      try {
        await logout();
      } catch (_) {
        // noop
      }
      authStore.setLogout();
      router.push({ name: "SignInPage" }).then(() => router.go(0));
    };

    return { isOpen, goToSubscriptions, logoutNow };
  },
});
</script>

<style lang="scss" scoped>
.bf-required {
  background: var(--surface) !important;
  border: 1px solid var(--border);

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 16px;
    background: var(--brand-gradient);
    box-shadow: var(--brand-shadow);
  }

  &__title {
    font-size: 18px;
    font-weight: 800;
    color: var(--text);
  }

  &__text {
    font-size: 13px;
    color: var(--text2);
  }
}
</style>
